import styles from '../styles/main.module.css';

const Osusu = () => {
    return (
        <main className={`${styles.main} ${styles.mainJaasWorks}`}>
            <div className={styles.projectDetails}>
                <div className={styles.projectTitle}>
                    <h3 className={styles.projectTitle}>
                        Osusu
                    </h3>
                </div>
                <div className={styles.projectDescription}>
                    <p className={styles.projectDescription}>
                        Helping businesses work on their savings and dispensing culture.
                    </p>
                </div>
                <div className={styles.projectsLink}>
                    <a href="/" className={styles.projectLink}>www.osusu.com</a>
                </div>
            </div>

            {/* <svg width="90" height="107" viewBox="0 0 90 107" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_11_197)">
            <path d="M43.8216 59.4767C44.3961 59.1776 45.0797 59.1753 45.6562 59.4703L72.5213 73.2196C73.973 73.9626 73.973 76.0374 72.5213 76.7804L45.6562 90.5297C45.0797 90.8247 44.3961 90.8224 43.8216 90.5233L17.4081 76.774C15.9727 76.0269 15.9727 73.9731 17.4081 73.226L43.8216 59.4767Z" fill="black" fill-opacity="0.01"/>
            </g>
            <path d="M10 25.8032C10 22.2147 11.9229 18.9012 15.0386 17.1208L40.0386 2.83508C43.1129 1.07832 46.8871 1.07832 49.9614 2.83508L74.9614 17.1208C78.0771 18.9012 80 22.2147 80 25.8032V54.1968C80 57.7853 78.0771 61.0988 74.9614 62.8792L49.9614 77.1649C46.8871 78.9217 43.1129 78.9217 40.0386 77.1649L15.0386 62.8792C11.9229 61.0988 10 57.7853 10 54.1968V25.8032Z" fill="#E3FFF1"/>
            <path d="M13.333 27.4321C13.333 23.8637 15.2345 20.5657 18.3226 18.7778L39.9893 6.23399C43.0886 4.43967 46.9108 4.43967 50.01 6.23399L71.6767 18.7778C74.7649 20.5657 76.6663 23.8637 76.6663 27.4321V52.5677C76.6663 56.1361 74.7649 59.4341 71.6767 61.222L50.01 73.7659C46.9108 75.5602 43.0886 75.5602 39.9893 73.7659L18.3226 61.222C15.2345 59.4341 13.333 56.1361 13.333 52.5677V27.4321Z" fill="#57EBA1"/>
            <path d="M45 43.139C45 39.2908 47.2081 35.7841 50.6784 34.1211L71.8928 23.9545C74.1054 22.8942 76.6667 24.5069 76.6667 26.9605V52.5679C76.6667 56.1363 74.7652 59.4343 71.677 61.2222L50.0035 73.77C47.7812 75.0566 45 73.453 45 70.8853L45 58.3334L45 43.139Z" fill="#39D98A"/>
            <path d="M13.333 26.9681C13.333 24.5126 15.8979 22.8999 18.1108 23.964L39.3332 34.1687C42.797 35.8343 44.9997 39.3376 44.9997 43.181V69.5623C44.9997 69.5623 45.027 71.9706 45.588 72.7813C46.0688 73.476 46.8417 73.9563 47.5409 74.1063C48.5508 74.323 49.5875 73.9914 49.5875 73.9914C46.751 75.6454 43.2452 75.6508 40.4035 74.0057L18.3226 61.222C15.2345 59.4341 13.333 56.1361 13.333 52.5677V26.9681Z" fill="#06C270"/>
            <defs>
            <filter id="filter0_d_11_197" x="0.331543" y="43.2507" width="89.2783" height="63.4986" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset/>
            <feGaussianBlur stdDeviation="8"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.027451 0 0 0 0 0.870588 0 0 0 0 0.501961 0 0 0 0.4 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11_197"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11_197" result="shape"/>
            </filter>
            </defs>
            </svg>


            <div className={styles.projectImg}>

            </div> */}
        </main>
    );
}
 
export default Osusu;